import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Feature } from '../../package/model/model.feat';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css']
})
export class PackageComponent implements OnInit {
  @Input() data: any[];
  @Input() allfeatures: Feature[];
  @Output()  package : EventEmitter<any> = new EventEmitter();
  @Input() customPack: any[];


  list:any;
  selected :any;
  item : any;
  activepkg:any;
  public buypkg:boolean=true;
  public newarr=[];
  public ischeck:boolean=false;
  public ppkk:boolean=false;
  public pkgfilter:any;
  public isupdown:boolean=true;
  public filterpdata: any[]
  constructor() {  }

  select(item:any) {
      this.selected = item; 
      console.log("AAAAAAAA",this.selected);
  };

  isActive(id:number) 
  {
      return this.selected === id;
  };

  selectedpkg(rowdata:any)
  {
    console.log(rowdata);
    if(parseInt(sessionStorage.getItem("id_package")) > 0)
    {
      this.data.forEach(ele=>{
        if(ele.isselected)
        {
          if(ele.fixed_charge > rowdata.fixed_charge) // Downgrade package subscription
          {
            this.isActive(rowdata.id);
            console.log("IIIIIII",rowdata.id);
            this.package.emit({pkgdata:rowdata, type:3, oldpkg:ele});
          }
          if(ele.fixed_charge < rowdata.fixed_charge) //upgrade package subscription
          {
            this.isActive(rowdata.id);
            console.log("IIIIIII",rowdata.id);
            this.package.emit({pkgdata:rowdata, type:4, oldpkg:ele});
          }
        }      
      });
    }
    else
    {
      if(parseInt(sessionStorage.getItem("id_package")) < 0) //- Re-create Subscription on cancell or failed
      {
        this.isActive(rowdata.id);
        console.log("IIIIIII",rowdata.id);
        this.package.emit({pkgdata:rowdata, type:2});
      }
      else   //--------   On Fresh subscription.
      {
        this.isActive(rowdata.id);
        console.log("IIIIIII",rowdata.id);
        this.package.emit({pkgdata:rowdata, type:1});
      }
      
    }
    
    /* if(parseInt(sessionStorage.getItem("id_package")) < 1)
    {
      this.isActive(rowdata.id);
      console.log("IIIIIII",rowdata.id);
      this.package.emit(rowdata);
    }
    else
    {
      alert("You have an active Subscription. If you want to buy another then need to cancel current subscription");
    } */
    
  }

  OnSelectChange(event:any)
  {    
    if(event.checked)
    {
      this.ischeck=true;
    }
    else
    {
      this.ischeck=false;
    }
  }
  
  ngOnInit() {

    /* if(parseInt(sessionStorage.getItem("id_package")) > 0)
    {
      this.pkgfilter = (this.data).filter(function (entry:any) {
        // console.log(entry);
        return entry.pkgid == parseInt(sessionStorage.getItem("id_package"));
      });  
      try{
        let currcost = this.pkgfilter[0].fixed_charge;
        this.data.forEach(ele=>{
          if(ele.fixed_charge==currcost)
            this.filterpdata.push({pkgid:ele.pkgid,name:ele.name,fixed_charge:ele.fixed_charge,icon:"account_circle",minutes:ele.minutes, features:ele.features, isselected:true, notselected:false, mog_dialer:ele.mog_dialer, mog_dialer_cost:ele.mog_dialer_cost, did:ele.did, did_rate:ele.did_rate, setup_cost:ele.setup_cost, sms:ele.sms, ringless_vm:ele.ringless_vm, button:"Selected", btntext:"Purchased"});
          if(ele.fixed_charge < currcost)
            this.filterpdata.push({pkgid:ele.pkgid,name:ele.name,fixed_charge:ele.fixed_charge,icon:"account_circle",minutes:ele.minutes, features:ele.features, isselected:false, notselected:true, mog_dialer:ele.mog_dialer, mog_dialer_cost:ele.mog_dialer_cost, did:ele.did, did_rate:ele.did_rate, setup_cost:ele.setup_cost, sms:ele.sms, ringless_vm:ele.ringless_vm, button:"Selected", btntext:"Downgrade"});
          if(ele.fixed_charge > currcost)
            this.filterpdata.push({pkgid:ele.pkgid,name:ele.name,fixed_charge:ele.fixed_charge,icon:"account_circle",minutes:ele.minutes, features:ele.features, isselected:false, notselected:true, mog_dialer:ele.mog_dialer, mog_dialer_cost:ele.mog_dialer_cost, did:ele.did, did_rate:ele.did_rate, setup_cost:ele.setup_cost, sms:ele.sms, ringless_vm:ele.ringless_vm, button:"Selected", btntext:"Upgrade"});
        });
        this.isupdown=true;        
      }
      catch(e)
      {
        this.isupdown=false;        
      }
    } */

    // if(sessionStorage.getItem("type")=="3")
      // this.buypkg=false;
    console.log(this.allfeatures);
    console.log(this.data);
    if(this.allfeatures.length==15)
      this.ppkk=true;
  
  }

  
}
